function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.142 9.06l17.96-7.974-6.05 18.692-3.141-8.486L.14 9.061zm9.292 1.651l2.57 6.955 4.968-15.322L2.254 8.888l7.18 1.823z"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19"
  }, props), _ref);
}

export default SvgLocation;